"use strict";
/**
 *
 * Script to scroll To a given target smoothly.
 *
 * The target is defined using the following attribute data-scroll-to="ID_of_target"
 * Example:
 * <a data-scroll-to="#results1"> This link will scrolls to an element with the id="results1".
 * if you require different scroll offset use data-scroll-offset="40" where 40 marks offset in pixels
 *
 */
function scrollToTarget(trigger) {
    var destination = jQuery(trigger.attr('data-scroll-to')), offsetAttr = jQuery(trigger.attr('data-scroll-offset')), ifOffset = offsetAttr ? offsetAttr.selector : 110, offset = ifOffset;
    jQuery('html,body').animate({
        scrollTop: (destination.offset().top - offset)
    }, 500);
}
(function ($) {
    $(document).ready(function () {
        if ($('[data-scroll-to]').length > 0) {
            $('[data-scroll-to]').click(function (e) {
                e.preventDefault();
                scrollToTarget($(this));
            });
        }
    });
})(jQuery);
